import EmailSignUpBlock, { EmailSignUpBlockProps } from './EmailSignUpBlock';
import withInteractor from './EmailSignUp.interactor';
import withPresenter from './EmailSignUp.presenter';

export type { EmailSignUpBlockProps };
export default withInteractor(withPresenter(EmailSignUpBlock));
